import React from "react";
import { Trans, useTranslation } from "react-i18next";
import tw, { css } from "twin.macro";

import { BookMeeting } from "../../components/BookMeeting";
import Card from "../../components/Card";
import { Container } from "../../components/Container";
import ListWithBullet from "../../components/ListWithBullet";
import { getTranslationList } from "../../utils/common";

const cards = css`
  ${tw`py-8 max-w-5xl mx-auto flex flex-wrap items-center`}

  .twoOtionsCardHeader {
    ${tw`mt-20`}
  }
  .preCardTitle {
    ${tw`text-[1.3rem] font-bold`}
  }
  div > .twoOptionsCard {
    ${tw`md:max-h-[1020px] md:min-w-[349px] rounded-[4rem] flex-grow`}
    > h3 {
      ${tw`bg-white mt-0 w-full text-[2rem]`}
    }
    > .cardContent {
      ${tw`mt-6 mb-0`}
      > p {
        ${tw`text-[1.5rem]`}
      }
      > ul {
        ${tw`text-[1.1rem]`}
      }
    }
  }
  a > .searchCard {
    ${tw`w-full border-none px-0 mx-0 max-h-20`}
  }

  p > a {
    ${tw`px-0`}
  }

  svg {
    ${tw`mx-auto fill-current`}
    >g {
      ${tw`stroke-current`}
    }
  }
`;

const TwoOptions: React.FC = ({ ...rest }) => {
  const { t } = useTranslation();
  const doItSelfList = getTranslationList(t, "index.twoOptions.doItSelf.list");
  const manageForMeList = getTranslationList(t, "index.twoOptions.manageForMe.list");

  return (
    <Container {...rest}>
      <section css={cards}>
        <h2 tw="max-w-4xl mx-auto text-center">{t("index.twoOptions.header")}</h2>
        <p tw="max-w-4xl mx-auto text-center">{t("index.twoOptions.subHeader")}</p>
        <div tw="my-8 mx-auto text-center max-w-prose text-xl flex flex-col md:flex-row gap-8">
          <div tw="sm:max-w-md sm:mx-auto md:max-w-none flex flex-col">
            <p className="preCardTitle">{t("index.twoOptions.doItSelf.header")}</p>
            <Card className="twoOptionsCard" header={t("index.twoOptions.doItSelf.triangularPlatform")}>
              <p tw="sm:mb-10">{t("index.twoOptions.doItSelf.description")}</p>
              <ListWithBullet list={doItSelfList} />
            </Card>
          </div>

          <div tw="sm:max-w-md sm:mx-auto md:max-w-none flex flex-col">
            <p className="preCardTitle">{t("index.twoOptions.manageForMe.header")}</p>
            <Card
              className="twoOptionsCard"
              header={<Trans i18nKey={t("index.twoOptions.manageForMe.agencyServices")} components={{ br: <br /> }} />}
            >
              <p tw="sm:mb-10">{t("index.twoOptions.manageForMe.description")}</p>
              <ListWithBullet list={manageForMeList} />
            </Card>
          </div>
        </div>
        <BookMeeting commentFirst={true} />
      </section>
    </Container>
  );
};

export default TwoOptions;
